import { render, staticRenderFns } from "./EmotionDetailContrast.vue?vue&type=template&id=12e76265&scoped=true&"
import script from "./EmotionDetailContrast.vue?vue&type=script&lang=js&"
export * from "./EmotionDetailContrast.vue?vue&type=script&lang=js&"
import style0 from "./EmotionDetailContrast.vue?vue&type=style&index=0&id=12e76265&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e76265",
  null
  
)

export default component.exports